import { useGetPortfolioChangesQuery } from "../../../redux";

const usePortfolioChanges = () => {
    const data = useGetPortfolioChangesQuery();
    return { ...data };
};

export default usePortfolioChanges;